<template>
    <div class="page px-9">
        <div class="grid grid-cols-1 gap-9">
            <div class="text-30 text-a-blue-0069a8 px-8">
                <div class="flex justify-center">โหลด<img class="w-20 px-2" src="../../../assets/icon/ic-splus.svg" alt=""/>แอปพลิเคชั่น</div>
                <div class="flex justify-center text-center">และกรอกโค้ดที่เพื่อนคุณส่งให้รับคะแนนทันที</div>
            </div>
            <div class="flex justify-center">
                <img class="w-52" src="../../../assets/icon/ic-getcode.png" alt=""/>
            </div>
            <div class="flex-1">
                <div class="flex bg-white rounded-lg">
                    <div class="flex justify-center w-full text-22 py-2.5">{{ code }}</div>
                    <div class="flex-none bg-green-1 text-white text-22 p-2.5 rounded-r-lg"
                        v-clipboard:copy="code"
                        v-clipboard:success="onCopy">คัดลอก</div>
                </div>
                <div class="flex justify-center pt-4 px-8">
                    <div class="text-center text-16 text-a-gray-666666">
                        *นำโค้ดนี้ไปกรอกในหน้า “กิจกรรมเพื่อนแนะนำเพื่อน” หลังจากที่ลงทะเบียนสำเร็จ
                    </div>
                </div>
            </div>
            <div class="flex border-t border-white pt-4">
                <div class="flex pt-6 px-4 border-r border-white">
                    <img src="../../../assets/logo/logo-splus@3x.png" alt=""/>
                </div>
                <div class="felx-none w-full px-4">
                    <div class="text-center text-16 text-a-gray-666666">ดาวน์โหลดเลยที่นี่</div>
                    <img src="../../../assets/icon/ic-app-download.png" alt=""/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GetCode',
    data: function() {
        return {
            code: '',
        }
    },
    created: function() {
        this.getCode();
    },
    methods: {
        getCode: function() {
            if (!this.$route.query.ref) return ;
            this.code = this.$route.query.ref
            return this.code
        }
    }
}
</script>
